import React, { useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import CustomTable from "app/components/Table";
import { TableHeaderColumnType } from "app/components/Table/types";
import EditableColumn from "../../../../../../../../components/EditableColumn";
import { styled } from "@mui/material/styles";
import { MODES } from "utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { CorelationAnswer } from "app/containers/Questions/types";
import { actions } from "app/containers/Questions/redux/slice";
import { selectAnswer } from "app/containers/Questions/redux/selector";
import CustomTableRow from "app/components/TableRow";
import { selectDirection } from "styles/theme/slice";
import useDebounceEffect from "utils/hooks/useDebounceEffect";
import PrimaryButton from "app/components/Buttons/PrimaryButton";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import DeleteForeverTwoToneIcon from "@mui/icons-material/DeleteForeverTwoTone";
interface StyledCellProps {
  minWidth?: string | number;
  maxWidth?: string | number;
  fontFamily?: string;
}

const StyledTableCell = styled("div")(
  ({ minWidth, maxWidth, fontFamily }: StyledCellProps) => ({
    flex: 1,
    display: "flex",
    alignItems: "center",
    padding: "14px 16px",
    "&:last-of-type": {
      borderRight: "none",
    },
    backgroundColor: "transparent",
    textAlign: "unset",
    whiteSpace: "nowrap",
    height: 50,
    minWidth: minWidth || "auto",
    maxWidth: maxWidth || "none",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#3C3C43",
  })
);

const Headers: TableHeaderColumnType[] = [
  {
    id: "#",
    label: "HASH",
    align: "left",
    minWidth: 80,
    sortable: false,
  },
  {
    id: "rightAnswer",
    label: "LEFT",
    align: "left",
    minWidth: 500,
    sortable: false,
  },
  {
    id: "difficulty",
    label: "RIGHT",
    align: "left",
    minWidth: 500,
    sortable: false,
  },
];

const Data: CorelationAnswer = {
  _id: "",
  left: "",
  right: "",
};

const MAX_ANSWER = 7;
const Correlation = ({
  disabled,
  mode,
}: {
  disabled?: boolean;
  mode: MODES;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const direction = useSelector(selectDirection);
  const answer = useSelector(selectAnswer);

  const maxNotReached = (answer.correlation?.length ?? 0) < MAX_ANSWER;
  useDebounceEffect(
    () => {
      if (!answer?.correlation?.length) {
        dispatch(actions.setCoRelationAnswer(Data));
        return;
      }
      return () => {};
    },
    [answer?.correlation],
    100
  );

  const handleAddAnswer = () => {
    if (maxNotReached) {
      dispatch(actions.setCoRelationAnswer(Data));
      return;
    }
  };
  const disabledDelete = answer?.correlation?.length == 1 || disabled;

  return (
    <CustomTable headers={Headers}>
      {answer.correlation?.map((item, index) => (
        <CustomTableRow key={index}>
          <StyledTableCell minWidth={80} maxWidth={80}>
            <Box
              sx={{
                paddingY: "8px",
              }}
            >
              {index + 1}
            </Box>
          </StyledTableCell>
          <StyledTableCell minWidth={400} maxWidth={400}>
            <EditableColumn
              value={item?.left || ""}
              isOdd={index % 2 === 0}
              innerContainerStyle={{
                maxWidth: "100%",
              }}
              disabled={disabled}
              inputStyle={{
                background: "transparent",
              }}
              onSave={(val) => {
                dispatch(
                  actions.setUpdateAnswer({
                    index: index,
                    type: "correlation",
                    key: "left",
                    value: val,
                  })
                );
              }}
            />
          </StyledTableCell>
          <StyledTableCell minWidth={400} maxWidth={400}>
            <EditableColumn
              value={item?.right || ""}
              isOdd={index % 2 === 0}
              innerContainerStyle={{
                maxWidth: "100%",
              }}
              inputStyle={{
                background: "transparent",
              }}
              onSave={(val) => {
                dispatch(
                  actions.setUpdateAnswer({
                    index: index,
                    type: "correlation",
                    key: "right",
                    value: val,
                  })
                );
              }}
            />
          </StyledTableCell>
          <StyledTableCell
            style={{ justifyContent: "flex-end" }}
            maxWidth={100}
            minWidth={100}
          >
            <IconButton
              sx={{
                width: "40px",
                height: "24px",
                borderRadius: "4px",
              }}
              disabled={disabledDelete}
              onClick={() => {
                dispatch(
                  actions.setDeleteAnswer({
                    index: index,
                    type: "correlation",
                  })
                );
              }}
            >
              <DeleteForeverTwoToneIcon
                sx={{
                  fontSize: "16px",
                  color: disabledDelete ? "#ccc" : "#E24399",
                }}
              />
            </IconButton>
          </StyledTableCell>
        </CustomTableRow>
      ))}
      <CustomTableRow key={"add"} style={{ backgroundColor: "#fff" }}>
        <StyledTableCell maxWidth={80} minWidth={80}>
          &nbsp;
        </StyledTableCell>
        <StyledTableCell maxWidth={400} minWidth={400}>
          &nbsp;
        </StyledTableCell>
        <StyledTableCell maxWidth={400} minWidth={400}>
          &nbsp;
        </StyledTableCell>

        <StyledTableCell
          style={{ justifyContent: "flex-end" }}
          maxWidth={100}
          minWidth={100}
        >
          <PrimaryButton
            sx={{ width: 145 }}
            startIcon={<AddIcon />}
            disabled={!maxNotReached}
            onClick={handleAddAnswer}
            label={t("COMMON.BUTTONS.ADD_NEW_ANSWER")}
          />
        </StyledTableCell>
      </CustomTableRow>
    </CustomTable>
  );
};

export default Correlation;
